import { DatePicker } from "jalali-react-datepicker";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import * as Constants from "../../constants/urls";
import Loading from "../Loading/Loading";
import { useCookies } from "react-cookie";
import RightMenu from "../RightMenu";
import { Drawer } from "@material-ui/core";
import Header from "../Header/Header";
import Pagination from "react-js-pagination";
import Breadcrumb from "../Breadcrumb/Breadcrumb";

const ExcelSellReport = () => {

    const [cookies, setCookie, removeCookie] = useCookies();
    const [loading, setLoading] = useState(0);
    const [data, setData] = useState(undefined);

    const [state, setState] = useState({ right: false });

    const toggleDrawer = (anchor, open) => (event) => {
           if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
               return;
           }
           setState({ ...state, [anchor]: open });
       };
useEffect(()=>{
    setInterval(() => {
        intervalGet(data!=undefined?data.current_page:1);
      }, 30000);
},[])
       
    const getStatus = (id) => {
        let name="";
        if(id==1)
        name=<><div className="spinner mx-auto" style={{width:"20px",height:"20px"}}></div></>
        if(id==2)
        name=<span className="badge badge-pill badge-success p-2">اماده</span>
        if(id==3)
        name=<span className="badge badge-pill badge-danger p-2">ناموفق</span>
     return name;
    }
    const timeToDate=(unixTimestamp)=>{
        const date = new Date(unixTimestamp);  
        return date.toDateString(); 
    }
    const get=(page)=>{
        setLoading(true);
        const url = Constants.apiUrl + "/api/excel/index?page="+page;
        axios
            .get(url, {
                headers: {
                    Authorization: "Bearer " + cookies.user_server_token,
                },
            })
            .then((response) => {
                setData(response.data);
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            });
    }
    const intervalGet=(page)=>{
         const url = Constants.apiUrl + "/api/excel/index?page="+page;
        axios
            .get(url, {
                headers: {
                    Authorization: "Bearer " + cookies.user_server_token,
                },
            })
            .then((response) => {
                setData(response.data);
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            });
    }
    useEffect(()=>{
        setLoading(true);
        const url = Constants.apiUrl + "/api/excel/index";
        axios
            .get(url, {
                headers: {
                    Authorization: "Bearer " + cookies.user_server_token,
                },

            })
            .then((response) => {

                setData(response.data);
                setLoading(false);

            })
            .catch((e) => {
                setLoading(false);

            });
    },[]) 

    return (
        <>
                    {loading ? <Loading /> : ""}
                    {/* <Breadcrumb title={"گزارشات اکسل"} /> */}

        
            <div style={{ display: "flex", alignItems: "center"  }}>
                <div className="container-fluid" >
 
                    <div className="table-responsive mt-5 mb-5">
                            <table className="table table-hover table-bordered  ">
                                <thead>
                                    <tr className="">
                                        <td>
                                            <span>
                                                #
                                            </span>

                                        </td>
                                        <td>
                                            <span>
                                                نوع گزارش
                                            </span>

                                        </td>
                                        <td>
                                            <span>
                                                نام فایل
                                            </span>

                                        </td>
                                        <td>
                                            <span>
                                                گزارش گیرنده
                                            </span>

                                        </td>
                                        <td>
                                            <span>
                                                وضعیت
                                            </span>

                                        </td>
                                        <td>
                                            <span>
                                                تاریخ گزارش
                                            </span>

                                        </td>
                                        <td>
                                            <span>
                                              دانلود
                                            </span>

                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data != undefined && data.data.map((item, index) => {
                                        return (
                                            <tr>
                                                <td scope="row">{item.id}</td>
                                                <td>{item.type}</td>
                                                <td>{item.file}</td>
                                                <td>{item.user.name}</td>
                                                <td>{getStatus(item.status)}</td>
                                                <td>{timeToDate(item.created_at)}</td>
                                                <td>
                                                    {item.status==2 &&
                                                    <a target="_blank" href={Constants.ossUrl + "/excel/"+item.file} className="btn btn-outline-success">
                                                        دانلود
                                                    </a>}
                                                </td>
                                            </tr>
                                        );
                                    })
                                    }

                                </tbody>

                            </table>
                        </div>

                        <div className="pager Page navigation example">
                    {data && (
                        <Pagination
                            totalItemsCount={data.total}
                            activePage={data.current_page}
                            itemsCountPerPage={data.per_page}
                            onChange={(number) => {
                                get(number);
                            }}
                            itemClass="page-item"
                            linkClass="page-link"
                            firstPageText="اولین صفحه"
                            lastPageText="آخرین صفحه"
                            nextPageText="بعدی"
                            prevPageText="قبلی"
                            activeClass="pageactive"
                        />
                    )}
                </div>
                    </div>
                </div>
         </>
    )
}
export default ExcelSellReport;
